import React, { ReactElement } from 'react';
import './style.scss';
import { IconName, findIcon } from 'utils/handleIcon';
import { TwoSelections } from 'views/mutual/inputRadio';
import { CardLabel } from 'views/mutual/questionCard';
import { IconSize, SvgIcon } from 'views/mutual/svgIcon';
import { TemplateProps } from 'views/templates/accountOpen/common';

export const IdentificationQuestionTop = ({ isUpdate }: TemplateProps) => {
  const icon = findIcon(IconName.nonResidenceCardIDs);
  return (
    <>
      <div className="identificationQuestionTop-personal">
        <CardLabel
          letter={<>{!isUpdate ? <>&#10106;</> : <>&#10102;</>}お客様の本人確認書類について</>}
          sentence="以下のいずれか1点をお持ちですか？"
          help="運転免許証・マイナンバーカード・運転経歴証明書"
        />
        <SvgIcon icon={icon} size={IconSize.icon_xl} />
      </div>
    </>
  );
};

interface IdentificationQuestionBottomProps {
  selected: boolean | null;
  onChange: (value: boolean) => void;
  error: string | undefined;
}

export const IdentificationQuestionBottom = (props: IdentificationQuestionBottomProps) => {
  return (
    <>
      <div className="identificationQuestionBottom">
        <TwoSelections name="IdentificationQuestion" {...props} />
      </div>
    </>
  );
};
